import { c as _c } from "react/compiler-runtime";
import { getOrgProxyConfigsByProxyConfigIdOptions } from '@onefootprint/fetch-dashboard';
import type { ExternalApiSource } from '@onefootprint/request-types/dashboard';
import { useQuery } from '@tanstack/react-query';
const useProxyConfigs = nodeDataSource => {
  const $ = _c(14);
  const proxy = typeof nodeDataSource === "object" && "proxy" in nodeDataSource ? nodeDataSource.proxy : undefined;
  const proxyConfigId = proxy?.configId;
  const sandboxProxyConfigId = proxy?.sandboxConfigId;
  const t0 = proxyConfigId ?? "";
  let t1;
  if ($[0] !== t0) {
    t1 = getOrgProxyConfigsByProxyConfigIdOptions({
      path: {
        proxyConfigId: t0
      },
      headers: {
        "x-is-live": "true"
      }
    });
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = !!proxyConfigId;
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = {
      ...t1,
      enabled: t2
    };
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    data: proxyConfig,
    isLoading: isLoadingLiveProxyConfig
  } = useQuery(t3);
  const t4 = sandboxProxyConfigId ?? "";
  let t5;
  if ($[5] !== t4) {
    t5 = getOrgProxyConfigsByProxyConfigIdOptions({
      path: {
        proxyConfigId: t4
      },
      headers: {
        "x-is-live": "false"
      }
    });
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = !!sandboxProxyConfigId;
  let t7;
  if ($[7] !== t5 || $[8] !== t6) {
    t7 = {
      ...t5,
      enabled: t6
    };
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const {
    data: sandboxProxyConfig,
    isLoading: isLoadingSandboxProxyConfig
  } = useQuery(t7);
  const t8 = isLoadingSandboxProxyConfig || isLoadingLiveProxyConfig;
  let t9;
  if ($[10] !== proxyConfig || $[11] !== sandboxProxyConfig || $[12] !== t8) {
    t9 = {
      isLoading: t8,
      proxyConfig,
      sandboxProxyConfig
    };
    $[10] = proxyConfig;
    $[11] = sandboxProxyConfig;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  return t9;
};
export default useProxyConfigs;